class Sticky {
  constructor(options = {}) {
    this.config = {
      velocity: 0,
      ...options
    };
  }

  init() {
    this.checkScrollPosition();
    window.addEventListener('scroll', this.checkScrollPosition.bind(this));
  }

  checkScrollPosition() {
    const { velocity } = this.config;

    if (window.pageYOffset >= velocity) {
      document.body.classList.add('is-sticky');
    } else {
      document.body.classList.remove('is-sticky');
    }
  }
}

export default Sticky;
